import { OnInit, OnDestroy } from '@angular/core';

export abstract class Lifecycle implements OnInit, OnDestroy {
	abstract _initialize(): void;
	abstract _destroy(): void;

	constructor() {
		console.log('[>>>', this.constructor.name, '<<<]');
	}

	ngOnInit(): void {
		this._initialize();
	}

	ngOnDestroy(): void {
		this._destroy();
	}
}
